
  //import {Vue} from "vue-property-decorator";
  //import Component from "vue-class-component";
  import {Component, Prop, Vue, Watch} from "vue-property-decorator";
  import { Alert } from "@/addons/Alert";
  //import { http } from "@/config/HttpClient";
  import { DateTime } from "luxon";
  import { useConsultorioStore } from '../../store/consultorioStore';
  import { globalStore } from '../../store/globalStore';
  import { consultorioService } from '../../services/ConsultorioService';
  
  @Component({
    name: "FormEdit",
  })
  
  export default class FormEdit extends Vue {
    @Prop() paciente_selected!: any
    @Prop() swEditar!: boolean

    private globalStore = globalStore();
    private consultorioStore = useConsultorioStore();
    private consultorioService = consultorioService.getInstance();
    private tab:any = null;
    public dialog = false;
    $refs!: {
      form: HTMLFormElement,
    };
    
    paciente= {
			id: null,
      nombre: '',
      apellidos: '',
      fecha_nacimiento: '',
      genero: '',
      direccion: '',
      telefono: '',
      email: '',
      encargado: '',
      ci: '',
			estado_civil: '',
			edad: 0,
			ocupacion: '',
			procedencia: ''
  }
	valid = true;
	fecha = DateTime.now().toFormat('yyyy-MM-dd');
  generos= [{nombre: 'Masculino'}, {nombre:'Femenino'}]
    

	mounted(){
		this.cargarDatos();
		this.dialog = this.swEditar
	}

	close(){
		this.dialog=false;
	}
    
	guardar(){
		if (!this.$refs.form.validate()) {
			Alert.warning( `Lene todos los campos obligatorios (*)`)
				return;
			}
      
		Alert.confirm(`Se realizará la modificacion del paciente ${this.paciente.nombre} ${this.paciente.apellidos} `, 'Modificar paciente?').then(async result => {
				if(result.isConfirmed){
				await this.consultorioService.updatePaciente(this.paciente)
				this.limpiar()
				this.$emit('close')
				this.$emit('listar')
				}
		})
    
      
	}
    
	cargarDatos(){
		this.paciente.id = this.paciente_selected.id;
		this.paciente.nombre = this.paciente_selected.nombre;
		this.paciente.apellidos = this.paciente_selected.apellidos;
		this.paciente.fecha_nacimiento = this.paciente_selected.fecha_nacimiento;
		this.paciente.genero = this.paciente_selected.genero;
		this.paciente.direccion = this.paciente_selected.direccion;
		this.paciente.telefono = this.paciente_selected.telefono;
		this.paciente.email = this.paciente_selected.email;
		this.paciente.encargado = this.paciente_selected.encargado;
		this.paciente.ci = this.paciente_selected.ci;
		this.paciente.estado_civil = this.paciente_selected.estado_civil;
		this.paciente.edad = this.paciente_selected.edad;
		this.paciente.ocupacion = this.paciente_selected.ocupacion;
		this.paciente.procedencia = this.paciente_selected.procedencia;
	}
    
	limpiar(){
		this.paciente= {
			id: null,
			nombre: '',
			apellidos: '',
			fecha_nacimiento: '',
			genero: '',
			direccion: '',
			telefono: '',
			email: '',
			encargado: '',
			ci: '',
			estado_civil: '',
			edad: 0,
			ocupacion: '',
			procedencia: ''
		}
	}
	get loading(): boolean {
		return this.consultorioStore.loading;
	}
   
  }
  
